import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { TuiButton, TuiHint } from '@taiga-ui/core';

@Component({
  selector: 'pxc-patient-link-quick-action',
  templateUrl: './patient-link-quick-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, TuiButton, TuiHint],
})
export class PatientLinkQuickActionComponent {}
